import axios from 'axios';
import api_url from '../urls';
const actions = {

   async addArquivo (context, dados) {
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await axios.post(api_url.api_admin + 'v1/admin/add-arquivo',
         dados,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'multipart/form-data',
                'Accept' : 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
            .then(response => {
            console.log(response);
            })
            .catch((error) => {
              alert('Error')
           console.log(error.response);
             }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        
    }, 

    async addArquivoUrl (context, dados) {
      context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
    await axios.post(api_url.api_admin + 'v1/admin/add-arquivo-url',
       dados,
       {
          headers: {
            'authorization': AuthStr,
            'Accept' : 'application/json',
            'Content-Type': 'application/json'
          }
      })
          .then(response => {
          console.log(response);
          })
          .catch((error) => {
            alert('Error')
         console.log(error.response);
           }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  }, 

     allArquivos (context, valor) {

      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/arquivos',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           console.log(response.data);
          context.commit('ALL_ARQUIVOS', response.data)
      })
      .catch((error) => {
          console.log(error);
      });
      
  },
  allVideos (context, valor) {
    context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/all-videos',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
          context.commit('ALL_VIDEOS', response.data)
      })
      .catch((error) => {
          console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
   allSlides (context, valor) {
    context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/all-slides',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
          context.commit('ALL_SLIDES', response.data)
      })
      .catch((error) => {
          console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
    allAudios (context, valor) {
        context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/all-audios',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
          context.commit('ALL_AUDIOS', response.data)
      })
      .catch((error) => {
          console.log(error);
     }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
   allQuestionarios (context, valor) {

      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/all-questionarios',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
          context.commit('ALL_QUESTIONARIOS', response.data)
      })
      .catch((error) => {
          console.log(error);
      });
      
  },
  allExtras (context, valor) {

    context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/all-extras',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
          context.commit('ALL_EXTRAS', response.data)
      })
      .catch((error) => {
          console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
 async getArquivosExtras (context, value) {
console.log(value)
    context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
     await  axios.get(api_url.api_admin + 'v1/admin/all-arquivos-disciplina/' + value.tipo_arquivo_id + '/' + value.id,
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           console.log(response.data);
          context.commit('GET_EXTRAS', response.data)
      })
      .catch((error) => {
          console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
  async allArquivosTipo (context, value) {
    console.log(value)
        context.commit('PRELOADER_MUDAR',true)
          const USER_TOKEN = localStorage.getItem('access_token');
          const AuthStr = 'Bearer '.concat(USER_TOKEN)
         await  axios.get(api_url.api_admin + 'v1/admin/all-arquivos-tipo/' + value.tipo_arquivo_id,
           {
              headers: {
                  'authorization': AuthStr,
                  'Accept' : 'application/json',
                  'Content-Type': 'application/json'
              }
          })
          .then(response => {
               console.log(response.data);
              context.commit('ALL_ARQUIVOS_TIPO', response.data)
          })
          .catch((error) => {
              console.log(error);
            }).finally(()=> context.commit('PRELOADER_MUDAR',false))
          
      },
  async allArquivosDisciplina (context, value) {
    console.log(value)
        context.commit('PRELOADER_MUDAR',true)
          const USER_TOKEN = localStorage.getItem('access_token');
          const AuthStr = 'Bearer '.concat(USER_TOKEN)
         await  axios.get(api_url.api_admin + 'v1/admin/all-arquivos-disciplina/' + value.tipo_arquivo_id + '/' + value.id,
           {
              headers: {
                  'authorization': AuthStr,
                  'Accept' : 'application/json',
                  'Content-Type': 'application/json'
              }
          })
          .then(response => {
               console.log(response.data);
              context.commit('ALL_ARQUIVOS_DISCIPLINA', response.data)
          })
          .catch((error) => {
              console.log(error);
            }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      },
      async allArquivosDisciplinaProfessor (context, value) {
        console.log(value)
            context.commit('PRELOADER_MUDAR',true)
              const USER_TOKEN = localStorage.getItem('access_token');
              const AuthStr = 'Bearer '.concat(USER_TOKEN)
             await  axios.get(api_url.api_admin + 'v1/admin/all-arquivos-disciplina-professor/' + value.tipo_arquivo_id + '/' + value.funcionario_id,
               {
                  headers: {
                      'authorization': AuthStr,
                      'Accept' : 'application/json',
                      'Content-Type': 'application/json'
                  }
              })
              .then(response => {
                //   console.log(response.data);
                  context.commit('ALL_ARQUIVOS_TIPO', response.data)
              })
              .catch((error) => {
                  console.log(error);
                }).finally(()=> context.commit('PRELOADER_MUDAR',false))
          },
 async AddAquivoDisciplina (context, value) {

    context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
     await  axios.post(api_url.api_admin + 'v1/admin/add-arquivo-disciplina',
       {
           arquivo_id: value.oferta_arquivo_id,
           oferta_data_disciplina_id:value.oferta_data_disciplina_id,
           status:1,
           tipo_arquivo_id:value.tipo_arquivo_id
       },
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
         // context.commit('GET_EXTRAS', response.data)
      })
      .catch((error) => {
          console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
  async downloadArquivo (context, value) {

    context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
    
        axios({
            url: api_url.api_admin + 'v1/admin/download/'+value.id_arquivo,
            method: 'get',
            responseType: 'blob', // important
        
            
          }).then((response) => {
              console.log(response)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', value.nome_arquivo+'.'+value.extensao);
            document.body.appendChild(link);
            link.click();
          }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
  async allArquivosPaginaInicial (context, value) {
    //console.log(value)
        context.commit('PRELOADER_MUDAR',true)
          const USER_TOKEN = localStorage.getItem('access_token');
          const AuthStr = 'Bearer '.concat(USER_TOKEN)
         await  axios.get(api_url.api_admin + 'v1/admin/all-arquivos-disciplina/' + value.tipo_arquivo_id + '/' + value.id,
           {
              headers: {
                  'authorization': AuthStr,
                  'Accept' : 'application/json',
                  'Content-Type': 'application/json'
              }
          })
          .then(response => {
             //  console.log(response.data);
               if (value.tipo_arquivo_id == 1) {
                context.commit('ALL_ARQUIVOS_VIDEOS', response.data)
               }
               if (value.tipo_arquivo_id == 2) {
                context.commit('ALL_ARQUIVOS_SLIDES', response.data)
               }
               if (value.tipo_arquivo_id == 3) {
                context.commit('ALL_ARQUIVOS_AUDIOS', response.data)
               }
               if (value.tipo_arquivo_id == 5) {
                context.commit('ALL_ARQUIVOS_EXTRAS', response.data)
               }
              
          })
          .catch((error) => {
              console.log(error);
            }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      },
      async linkArquivo (context, value) {

        context.commit('PRELOADER_MUDAR',true)
          const USER_TOKEN = localStorage.getItem('access_token');
          const AuthStr = 'Bearer '.concat(USER_TOKEN)
        
         await  axios.get(api_url.api_admin + 'v1/admin/link_arquivo/'+value.id_arquivo,
           {
              headers: {
                  'authorization': AuthStr,
                  'Accept' : 'application/json',
                  'Content-Type': 'application/json'
              }
          }).then((response) => {
             
                context.commit('SETAR_LINK',response.data)

              }).finally(()=> context.commit('PRELOADER_MUDAR',false))
          
      },
      async addCuestionario (context, dados) {
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await axios.post(api_url.api_admin + 'v1/admin/addCuestionario',
         dados,
         {
            headers: {
                'Authorization': AuthStr,
                'Accept' : 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
            .then(response => {
            console.log(response);
            })
            .catch((error) => {
              alert('Error')
           console.log(error.response);
             }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        
    }, 
    async addArquivoComprovante (context, dados) {
      context.commit('PRELOADER_MUDAR',true)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
    await axios.post(api_url.api_admin + 'v1/admin/add-arquivo-pagamento',
       dados,
       {
          headers: {
              'Authorization': AuthStr,
              'Content-Type': 'multipart/form-data',
              'Accept' : 'application/json',
              'X-Requested-With':'XMLHttpRequest',
          }
      })
          .then(response => {
          console.log(response);
          })
          .catch((error) => {
            alert('Error')
         console.log(error.response);
           }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  }, 
  async EliminarAquivoDisciplina (context, value) {
    console.log(value)
        context.commit('PRELOADER_MUDAR',true)
          const USER_TOKEN = localStorage.getItem('access_token');
          const AuthStr = 'Bearer '.concat(USER_TOKEN)
         await  axios.get(api_url.api_admin + 'v1/admin/eliminar_arquivo_disciplina/' + value.id,
           {
              headers: {
                  'authorization': AuthStr,
                  'Accept' : 'application/json',
                  'Content-Type': 'application/json'
              }
          })
          .then(response => {
               console.log(response.data);
              //context.commit('ALL_ARQUIVOS_TIPO', response.data)
          })
          .catch((error) => {
              console.log(error);
            }).finally(()=> context.commit('PRELOADER_MUDAR',false))
          
      },
 
  
  
}

export default actions